import { render, staticRenderFns } from "./ScreenShareGrid.vue?vue&type=template&id=a1268498&scoped=true&"
import script from "./ScreenShareGrid.vue?vue&type=script&lang=js&"
export * from "./ScreenShareGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1268498",
  null
  
)

export default component.exports